import React from "react";
import classes from "../Projects/Projects.module.css";
import imga from "../Projects/shares.jpg";
import img2 from "../Projects/img.jpg";
import img3 from "../Projects/shape2.jpg";
import { Button, Card, Carousel } from "react-bootstrap";
import { FaExternalLinkAlt } from "react-icons/fa";

function Projects() {
  const data = [
    {
      img: imga,
      title: "File Pioneer",
      desc: "File sharing Projects in which a file can be shared with all the devices when they are connected to a network like wifi and can access all the files what user has uploaded and also file conversion can be possible.",
      link: "https://drive.google.com/file/d/1u2fM4vucfMp41uPn5nq0Z9CqhWJ0rMbs/view?usp=share_link",
    },
    {
      img: img2,
      title: "Online Mail Verification",
      desc: "This project is the simple functionality of the forget password in which we receive the verification mail from the root and with a code later that will get entered into the form to get or update to a new password.",
      link: "#",
    },
    {
      img: img3,
      title: "Image Shape Prediction and Detection",
      desc: "This project focuses on object detection and prediction using advanced computer vision techniques. It accurately identifies objects and predicts their classes, while also measuring their dimensions and gives the output audio format also",
      link: "#",
    },
  ];

  return (
    <div >

      <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
        <h2 >Projects</h2>
      </div>

      <div className={classes.mmm}>
        <Carousel>
          {data.map((slide, index) => (
            <Carousel.Item key={index}>
              <div style={{marginLeft:"20px",marginRight:"20px"}}>
                <Card>

                    <Card.Img
                      variant="top"
                      src={slide.img}
                      style={{ width: "30%", }}
                    />
                <Card.Body>
                  <Card.Title>{slide.title}</Card.Title>
                  <Card.Text>{slide.desc}</Card.Text>
                  <Button variant="primary" href={slide.link}>
                    Click here{" "}
                    <FaExternalLinkAlt  />
                  </Button>
                </Card.Body>
                </Card>
                </div>
            </Carousel.Item>
          ))}
        </Carousel>
      </div>
    </div>
  );
}

export default Projects;
